import { GiahoantienService } from 'src/services/giahoantien.service';
import { showToast } from 'src/utils/common';
import { NOTI_TYPES } from 'src/utils/constants';

import { AppAction } from './app.action';

export const GIAHOANTIEN_NEW_CARE_SUCCESS = 'GIAHOANTIEN:NEW_CARE_SUCCESS'
export const GIAHOANTIEN_LIST_SUCCESS = 'GIAHOANTIEN:FIND_ALL_SUCCESS'
export const GIAHOANTIEN_LIST_FAILD = 'GIAHOANTIEN:FIND_ALL_FAILD'
export const GIAHOANTIEN_COUNT_ASSIGN_SUCCESS = 'GIAHOANTIEN:COUNT_ASSIGN_SUCCESS'
export const GIAHOANTIEN_COUNT_ASSIGN_FAILD = 'GIAHOANTIEN:COUNT_ASSIGN_FAILD'

export const GIAHOANTIEN_CREATE_SUCCESS = 'GIAHOANTIEN:CREATE_SUCCESS'
export const GIAHOANTIEN_CREATE_FAILD = 'GIAHOANTIEN:CREATE_FAILD'

export const GIAHOANTIEN_IMPORT_SUCCESS = 'GIAHOANTIEN:IMPORT_SUCCESS'
export const GIAHOANTIEN_SAVE_SUCCESS = 'GIAHOANTIEN:SAVE_SUCCESS'
export const GIAHOANTIEN_SAVE_FAILD = 'GIAHOANTIEN:SAVE_SUCCESS'

export const GIAHOANTIEN_DEL_SUCCESS = 'GIAHOANTIEN:DEL_SUCCESS'
export const GIAHOANTIEN_DEL_FAILD = 'GIAHOANTIEN:DEL_FAILD'

export const GIAHOANTIEN_ONE_SUCCESS = 'GIAHOANTIEN:FIND_ONE_SUCCESS'
export const GIAHOANTIEN_ONE_FAILD = 'GIAHOANTIEN:FIND_ONE_FAILD'

export const GIAHOANTIEN_HISTORY_LIST_SUCCESS = 'GIAHOANTIEN:HISTORY_FIND_ALL_SUCCESS'
export const GIAHOANTIEN_HISTORY_LIST_FAILD = 'GIAHOANTIEN:HISTORY_FIND_ALL_FAILD'

export const GIAHOANTIEN_UPDATE_FILTER = 'GIAHOANTIEN:GIAHOANTIEN_UPDATE_FILTER'

export const GIAHOANTIEN_LIST_EXPORT_SUCCESS = 'GIAHOANTIEN:FIND_ALL_EXPORT_SUCCESS'
export const GIAHOANTIEN_LIST_EXPORT_FAILD = 'GIAHOANTIEN:FIND_ALL_EXPORT_FAILD'

export const GiahoantienAction = {
    list,
    findAssign,
    create,
    importData,
    saveData,
    update,
    del,
    assign,
    countAssign,
    history,
    findOne,
    updateFilter,
    saveDataUpload,
    findPackage,
    listExport,
    listNoLimit,
}

function updateFilter(payload) {
    return { type: GIAHOANTIEN_UPDATE_FILTER, data: payload }
}

function listNoLimit() {
    return (dispatch, getState) => {
      const { account } = getState()
      dispatch(AppAction.appLoading(true));
      GiahoantienService.listNoLimit().then((rs) => {
        dispatch(success({
            items: rs.data.values,
            total: rs.data.count
        }));
      }).catch((error) => {
        dispatch(failure(error));
      }).finally(() => {
        dispatch(AppAction.appLoading(false));
      })
    };
    function success(data) { return { type: GIAHOANTIEN_LIST_SUCCESS, data } }
    function failure(error) { return { type: GIAHOANTIEN_LIST_FAILD, error } }
  }

function countAssign() {
    return (dispatch) => {
        dispatch(AppAction.appLoading(true));
        GiahoantienService.countAssign().then((rs) => {
            dispatch(success(rs.data.total));
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: GIAHOANTIEN_COUNT_ASSIGN_SUCCESS, data } }
    function failure(error) { return { type: GIAHOANTIEN_COUNT_ASSIGN_FAILD, error } }
}

function findAssign(page = 0, count = 20) {
    return (dispatch, getState) => {
        const { giahoantien } = getState()
        dispatch(AppAction.appLoading(true));
        GiahoantienService.findAssign(page, count).then((rs) => {
            if (page === 0) {
                dispatch(success({
                    items: rs.data.values,
                    total: rs.data.count
                }));
            } else {
                dispatch(success({
                    items: [...giahoantien.items, ...rs.data.values],
                    total: rs.data.count
                }));
            }
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: GIAHOANTIEN_LIST_SUCCESS, data } }
    function failure(error) { return { type: GIAHOANTIEN_LIST_FAILD, error } }
}

function saveDataUpload(payload) {
    return (dispatch) => {
        dispatch(AppAction.appLoading(true));
        let count = 0
        for (let i = 0; i < payload.length; i += 200) {
            // eslint-disable-next-line no-loop-func
            GiahoantienService.save(payload.slice(i, i + 200)).then((rs) => {
                count += parseInt(rs.data.saved, 10)
                if (count === payload.length) {
                    dispatch(success(rs));
                    dispatch(AppAction.appLoading(false));
                }
            }).catch((error) => {
                dispatch(failure(error));
                dispatch(AppAction.appLoading(false));
            })
        }
    };

    function success(data) { return { type: GIAHOANTIEN_SAVE_SUCCESS, data } }
    function failure(error) { return { type: GIAHOANTIEN_SAVE_FAILD, error } }
}

function findPackage(ten_goi_cuoc) {    
    return (dispatch, getState) => {
        return new Promise((resolve, reject) => {
            // Perform your asynchronous operation (e.g., API call)
            GiahoantienService.findPackage(ten_goi_cuoc)
            .then(response => {
                // Handle the successful response
                resolve(response); // Resolve the promise with the response
            })
            .catch(error => {
                // Handle the error
                reject(error); // Reject the promise with the error
            });
        });
    };
}

function listExport() {
    return (dispatch, getState) => {
        return new Promise((resolve, reject) => {
            const { giahoantien } = getState();

            const { filter } = giahoantien;

            // Perform your asynchronous operation (e.g., API call)
            GiahoantienService.listExport(filter)
            .then(response => {
                // Handle the successful response
                dispatch(success(response));
                resolve(response); // Resolve the promise with the response
            })
            .catch(error => {
                // Handle the error
                dispatch(failure(error));
                reject(error); // Reject the promise with the error
            });
        });
    }
    function success(data) { return { type: GIAHOANTIEN_LIST_EXPORT_SUCCESS, data } }
    function failure(error) { return { type: GIAHOANTIEN_LIST_EXPORT_FAILD, error } }
}

function list() {
    return (dispatch, getState) => {
        const { giahoantien } = getState();
        dispatch(AppAction.appLoading(true));

        const { filter } = giahoantien;
        const page = filter.page;
        const limit = filter.limit;

        return new Promise((resolve, reject) => {
            GiahoantienService.findAll(filter.page, filter.limit, filter).then((rs) => {
                if (!!filter && filter.page === 0) {
                    dispatch(success({
                        items: rs.data.values,
                        total: rs.data.count,
                    }));
                } else {
                    const oldItems = giahoantien.items;
                    const rsDataValues = rs.data.values;

                    var uniqueItems = oldItems;
                    for (var i = limit * page; i < limit * page + limit; i++) {
                        if (typeof rsDataValues[i - limit * page] !== 'undefined') {
                            uniqueItems[i] = rsDataValues[i - limit * page];
                        } else if (typeof uniqueItems[i] !== 'undefined') {
                            delete uniqueItems[i];
                        }
                    }
                    
                    dispatch(success({
                        items: uniqueItems,
                        total: rs.data.count,
                    }));
                }
                resolve(rs);
            }).catch((error) => {
                dispatch(failure(error));
                reject(error);
            }).finally(() => {
                dispatch(AppAction.appLoading(false));
            })
        });
    };
    function success(data) { return { type: GIAHOANTIEN_LIST_SUCCESS, data } }
    function failure(error) { return { type: GIAHOANTIEN_LIST_FAILD, error } }
}

function importData(payload) {
    return { type: GIAHOANTIEN_IMPORT_SUCCESS, data: payload }
}

function saveData(payload) {
    return (dispatch) => {
        dispatch(AppAction.appLoading(true));
        let count = 0
        for (let i = 0; i < payload.length; i += 200) {
            // eslint-disable-next-line no-loop-func
            GiahoantienService.save(payload.slice(i, i + 200)).then((rs) => {
                count += parseInt(rs.data.saved, 10)
                if (count === payload.length) {
                    dispatch(success(rs));
                    dispatch(GiahoantienAction.list())
                    dispatch(AppAction.appLoading(false));
                }
            }).catch((error) => {
                dispatch(failure(error));
                dispatch(AppAction.appLoading(false));
            })
        }
    };

    function success(data) { return { type: GIAHOANTIEN_SAVE_SUCCESS, data } }
    function failure(error) { return { type: GIAHOANTIEN_SAVE_FAILD, error } }
}

function create(payload) {
    return dispatch => {
        dispatch(AppAction.appLoading(true));
        GiahoantienService.create(payload).then((rs) => {
            dispatch(success(rs));
            dispatch(GiahoantienAction.list())
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: GIAHOANTIEN_CREATE_SUCCESS, data } }
    function failure(error) { return { type: GIAHOANTIEN_CREATE_FAILD, error } }
}

function update(id, payload) {
    return dispatch => {
        dispatch(AppAction.appLoading(true));
        GiahoantienService.update(id, payload).then((rs) => {
            dispatch(success(rs));
            dispatch(GiahoantienAction.list())
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: GIAHOANTIEN_CREATE_SUCCESS, data } }
    function failure(error) { return { type: GIAHOANTIEN_CREATE_FAILD, error } }
}

function del(id) {
    return dispatch => {
        dispatch(AppAction.appLoading(true));
        GiahoantienService.delete(id).then((rs) => {
            dispatch(success(rs));
            dispatch(GiahoantienAction.list())
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: GIAHOANTIEN_DEL_SUCCESS, data } }
    function failure(error) { return { type: GIAHOANTIEN_DEL_FAILD, error } }
}

function findOne(id) {
    return (dispatch) => {
        dispatch(AppAction.appLoading(true));
        GiahoantienService.find(id).then((rs) => {
            dispatch(success(rs.data));
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: GIAHOANTIEN_ONE_SUCCESS, data } }
    function failure(error) { return { type: GIAHOANTIEN_ONE_FAILD, error } }
}

function assign(payload) {
    return dispatch => {
        dispatch(AppAction.appLoading(true));
        GiahoantienService.assign(payload).then((rs) => {
            showToast('success', "Phân chia dữ liệu thành công.")
            dispatch(GiahoantienAction.list())
        }).catch((error) => {
            showToast('error', "Phân chia dữ liệu thất bại.\nVui lòng thử lại lần sau.")
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
}


function history(payload) {
    return (dispatch, getState) => {
        const { giahoantien } = getState()
        dispatch(AppAction.appLoading(true));
        GiahoantienService.history(payload).then((rs) => {
            if (payload.page === 0) {
                dispatch(success({
                    items: rs.data.values,
                    total: rs.data.count
                }));
            } else {
                dispatch(success({
                    items: [...giahoantien.items, ...rs.data.values],
                    total: rs.data.count
                }));
            }
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: GIAHOANTIEN_HISTORY_LIST_SUCCESS, data } }
    function failure(error) { return { type: GIAHOANTIEN_HISTORY_LIST_FAILD, error } }
}